/*
 * @Description: user actions type
 */

export enum UserActionTypes {
  ACTION_GET_USER_INFO = 'ACTION_GET_USER_INFO',
}
